import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { rem } from 'polished';
import { Flex } from 'grid-styled';
import Link from 'components/Link';
import Text from 'components/Text';
import { SPACE, COLOR } from 'config';

import Card from './Card';
import { ImageCardContainer } from './ImageCard';
import Title from './Title';
import image from '../images/watch.jpg';
import youtube from '../images/youtube.svg';

const Icon = styled.img`
  margin-right: ${rem(SPACE[3])};
  width: ${props => props.width};
`;

const StyledText = styled(Text)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 0;
  margin-bottom: 0;
`;

const YoutubeWrapper = styled(Flex)`
  flex-direction: column;
  margin-top: 1rem;
`;

const StyledLink = styled(Link)`
  cursor: pointer;
  color: black !important;
  margin-bottom: 12px;
`;

const Video = ({ text, icon, url }) => (
  <StyledLink href={url}>
    <StyledText>
      <Icon src={icon} width="40px" />
      <FormattedMessage id={text} />
    </StyledText>
  </StyledLink>
);

Video.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

const WatchNow = () => {
  const icon = (
    <ImageCardContainer
      image={image}
      height="400"
      width="480"
      backgroundColor={COLOR.base}
      backgroundPositionX={'-50px'}
    />
  );

  return (
    <Card image={icon} flexDirection="row-reverse" noMargin mb={'3rem'}>
      <Title id="landing.skycoin.watchandlearn.title" />
      <StyledText mb={'24px'}>
        <FormattedHTMLMessage id="landing.skycoin.watchandlearn.description" />
      </StyledText>
      <YoutubeWrapper>
        <Video
          text="landing.skycoin.watchandlearn.youtube.video1"
          icon={youtube}
          url="https://www.youtube.com/watch?v=RjJo-8QWwkQ"
        />
        <Video
          text="landing.skycoin.watchandlearn.youtube.video2"
          icon={youtube}
          url="https://www.youtube.com/watch?v=Rv7yfpODBzU"
        />
        <Video
          text="landing.skycoin.watchandlearn.youtube.video3"
          icon={youtube}
          url="https://www.youtube.com/watch?v=rwdJRbRgaU8"
        />
        {/* <Video text="landing.skycoin.watchandlearn.youtube.video4" icon={youtube} url="https://www.youtube.com/watch?v=UxmgzBCv05Y" /> */}
      </YoutubeWrapper>
    </Card>
  );
};

export default WatchNow;



// WEBPACK FOOTER //
// ./src/components/SkycoinLanding/components/WatchNow.js